"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isAnyOptionDirty(currentSubcategory) {
    return currentSubcategory.options.reduce(function (state, option) { return state || option.fullOptionFormSettings.isDirty(); }, false);
}
exports.default = isAnyOptionDirty;
//# sourceMappingURL=isAnyOptionDirty.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/owa-options-core/lib/utils/isAnyOptionDirty.js
// module id = 1836
// module chunks = 2 39 105 108